<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="tx"><br/><br/></p>
<div class="image" id="pz22-1"><a id="page_10">
<p class="ser"><img alt="images/img-22-1.jpg" id="z22-1" src="images/img-22-1.jpg"/></p>
<p class="txcc" id="pz22-2"><i>BOY, OH, BOYSINGER’S!—Millie and Sam may be sweet on each other, but young Mike sticks to the pastries.</i></p></a></div><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter20.vue?d462934c